import * as THREE from 'three';
import { Shaders } from './shaders/shaders.js';

export class EyeDomeLightingMaterial extends THREE.RawShaderMaterial {
  neighbours!: Float32Array;
  private _neighbourCount = 0;

  constructor() {
    super();

    this.glslVersion = THREE.GLSL3;

    const uniforms = {
      screenWidth: { type: 'f', value: 0 },
      screenHeight: { type: 'f', value: 0 },
      edlStrength: { type: 'f', value: 1.0 },
      uNear: { type: 'f', value: 1.0 },
      uFar: { type: 'f', value: 1.0 },
      radius: { type: 'f', value: 1.0 },
      neighbours: { type: '2fv', value: [] as number[] },
      depthMap: { type: 't', value: null },
      uEDLColor: { type: 't', value: null },
      uEDLDepth: { type: 't', value: null },
      opacity: { type: 'f', value: 1.0 },
      uProj: { type: 'Matrix4fv', value: [] as number[] },
    };

    this.setValues({
      uniforms: uniforms,
      vertexShader: this._insertDefines(Shaders['edl.vs']),
      fragmentShader: this._insertDefines(Shaders['edl.fs']),
      lights: false,
    } as any);

    this.neighbourCount = 8;
  }

  getDefines(): string {
    return '#define NEIGHBOUR_COUNT ' + this._neighbourCount + '\n';
  }

  _insertDefines(source: string): string {
    const defines = this.getDefines();
    if (!defines) return source;
    return defines + source;
  }

  updateShaderSource(): void {
    const vs = this._insertDefines(Shaders['edl.vs']);
    const fs = this._insertDefines(Shaders['edl.fs']);

    this.setValues({
      vertexShader: vs,
      fragmentShader: fs,
    } as any);

    this.uniforms['neighbours'].value = this.neighbours;

    this.needsUpdate = true;
  }

  get neighbourCount(): number {
    return this._neighbourCount;
  }

  set neighbourCount(value: number) {
    if (this._neighbourCount !== value) {
      this._neighbourCount = value;
      this.neighbours = new Float32Array(this._neighbourCount * 2);
      for (let c = 0; c < this._neighbourCount; c++) {
        this.neighbours[2 * c + 0] = Math.cos((2 * c * Math.PI) / this._neighbourCount);
        this.neighbours[2 * c + 1] = Math.sin((2 * c * Math.PI) / this._neighbourCount);
      }

      this.updateShaderSource();
    }
  }
}
